import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rupiah'
})
export class RupiahPipe implements PipeTransform {

  transform(value: string | number): string {
    // Konversi value ke number dan handling jika string kosong
    const numValue = typeof value === 'string' ? Number(value) : value;

    if (isNaN(numValue) || numValue == null) {
      return 'Rp. 0';
    }

    // Pisahkan bagian integer dan desimal
    const parts = numValue.toString().split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1];

    // Format bagian integer dengan pemisah ribuan
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Gabungkan kembali dengan bagian desimal jika ada
    let result = formattedInteger;
    if (decimalPart) {
      result += ',' + decimalPart;
    }

    return `Rp. ${result}`;
  }
}
